<template>
  <div class="page flex-col">

    <div class="box_2 flex-col">
      <div class="image-wrapper_1 flex-row justify-between">
        <img
          class="image_2"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNG7ba570a83befcbe064b13fb9d24088c8.png'"
        />
        <img
          class="image_3"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNG6a94e3f80b0a881a2f82b16ad3e3a8f8.png'"
        />
        <div style="margin-left: -32vw;margin-top:-3.2vw"> <headerMask/> </div>
      </div>
      <div class="box_3 flex-row">
        <div class="block_1 flex-col">
          <span class="text_2">健康体适能测评仪</span>
          <span class="text_3">远程“检测-评估-干预”的主动健康闭环系统</span>
          <span class="text_4">特册运动评估，开具个性化运动处方，进行线上、线下运动管理与干预</span>
          <div class="section_1 flex-row justify-between">
            <div class="text-wrapper_1 flex-col"><span class="text_5">新技术</span></div>
            <div class="text-wrapper_2 flex-col"><span class="text_6">新手段</span></div>
            <div class="text-wrapper_3 flex-col"><span class="text_7">新功能</span></div>
          </div>
          <div class="image-wrapper_2 flex-row justify-between">
            <img
              class="image_4"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNGa98e530101816bb4fd86e7572bb22bb2.png'"
            />
            <img
              class="image_5"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNG1c8bf7fc218891ebe2a43fe23ca76584.png'"
            />
          </div>
        </div>
        <div class="image-wrapper_3 flex-row">
          <img
            class="thumbnail_3"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNGdbc7e5e88a1464a75b257daac2a334db.png'"
          />
          <img
            class="image_6"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNGb657df0c9f1898373e509abc993ae444.png'"
          />
        </div>
      </div>
 
    </div>
    <div class="box_5 flex-col">
      <div class="group_1 flex-row">
        <div class="block_2 flex-col"></div>
        <img
          class="thumbnail_4"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/996a7e3552fa44daa594d597df6a050a_mergeImage.png'"
        />
        <div class="image-text_1 flex-row justify-between">
          <div class="box_6 flex-col">
            <div class="block_3 flex-col"></div>
            <span class="text-group_1">硬件特点</span>
          </div>
          <div class="image-wrapper_5 flex-col">
            <img
              class="thumbnail_5"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNG0efce337b16177f7b543ef01704cf6f6.png'"
            />
          </div>
        </div>
      </div>
      <div class="group_2 flex-row justify-between">
        <div class="section_2 flex-col"></div>
        <div class="section_3 flex-col">
          <div class="box_7 flex-col"></div>
          <span class="text_8">实现运动姿态的精准识别</span>
        </div>
      </div>
      <div class="group_3 flex-row justify-between">
        <div class="block_4 flex-col"></div>
        <div class="block_5 flex-col">
          <div class="section_4 flex-col"></div>
          <span class="text_9">集成医疗级生命体征传感器</span>
        </div>
      </div>
      <div class="group_4 flex-row justify-between">
        <div class="group_5 flex-col"></div>
        <div class="group_6 flex-col">
          <div class="section_5 flex-col"></div>
          <span class="text_10">有氧/力量/平衡协调力训练器械</span>
        </div>
      </div>
      <div class="group_7 flex-row justify-between">
        <div class="group_8 flex-col"></div>
        <div class="group_9 flex-col">
          <div class="block_6 flex-col"></div>
          <span class="text_11">基于&nbsp;AI芯片的体形&nbsp;3D重构，创新图像识别算法</span>
        </div>
      </div>
      <div class="group_10 flex-row justify-between">
        <div class="box_8 flex-col"></div>
        <div class="box_9 flex-col">
          <div class="group_11 flex-col"></div>
          <span class="text_12">海量训练视频指导及运动处方</span>
        </div>
      </div>
      <div class="group_12 flex-row justify-between">
        <div class="group_13 flex-col"></div>
        <div class="group_14 flex-col">
          <div class="box_10 flex-row justify-between">
            <div class="group_15 flex-col"></div>
            <div class="group_16 flex-col"></div>
          </div>
          <span class="text_13">将精准运动检测技术与运动医学、健康科学相结合</span>
        </div>
      </div>
      <div class="group_17 flex-row justify-between">
        <div class="group_18 flex-col"></div>
        <span class="text_14">通过持续的机器学习和神经元网络计算技术</span>
      </div>
      <div class="group_19 flex-col"></div>
    </div>
    <div class="box_11 flex-col">
      <div class="box_12 flex-row">
        <div class="block_7 flex-col"></div>
        <img
          class="thumbnail_6"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/2957ad83f7e946b682b8c8aed857bb6c_mergeImage.png'"
        />
        <div class="image-text_2 flex-row justify-between">
          <div class="section_6 flex-col">
            <div class="box_13 flex-col"></div>
            <span class="text-group_2">核心优势</span>
          </div>
          <div class="image-wrapper_6 flex-col">
            <img
              class="thumbnail_7"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNG0efce337b16177f7b543ef01704cf6f6.png'"
            />
          </div>
        </div>
      </div>
      <div class="box_14 flex-row justify-between">
        <img
          class="image_7"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNG491f478d6a4b683ab82b474f0b7fa8f3.png'"
        />
        <div class="section_7 flex-col justify-between">
          <div class="box_15 flex-row justify-between">
            <div class="box_16 flex-col">
              <div class="text-group_3 flex-col justify-between">
                <span class="text_15">优势</span>
                <span class="text_16">01</span>
              </div>
              <img
                class="thumbnail_8"
                referrerpolicy="no-referrer"
                v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNG4e406f7946ef1e9b48a22821205ed49a.png'"
              />
            </div>
            <div class="text-wrapper_4 flex-col"><span class="text_17">3D识别更高精度的衍进</span></div>
          </div>
          <div class="box_17 flex-row justify-between">
            <div class="group_20 flex-col">
              <span class="text_18">做中国人自己的运动处方库</span>
              <img
                class="thumbnail_9"
                referrerpolicy="no-referrer"
                v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNG3efd7ef29d7e4ce6f003b62795aef2ee.png'"
              />
            </div>
            <div class="text-wrapper_5 flex-col justify-end">
              <span class="text_19">优势</span>
              <span class="text_20">02</span>
            </div>
          </div>
          <div class="box_18 flex-row justify-between">
            <div class="group_21 flex-col">
              <div class="text-group_4 flex-col justify-between">
                <span class="text_21">优势</span>
                <span class="text_22">03</span>
              </div>
            </div>
            <div class="group_22 flex-col">
              <span class="text_23">长者跌倒预防的更优方案</span>
              <img
                class="thumbnail_10"
                referrerpolicy="no-referrer"
                v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNG1a662e15cb2aaf165a44a40d0165eae0.png'"
              />
            </div>
          </div>
          <div class="box_19 flex-row justify-between">
            <div class="section_8 flex-col">
              <span class="text_24">更多关联监测的接入：骨密度、动态心电记录</span>
              <img
                class="thumbnail_11"
                referrerpolicy="no-referrer"
                v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNG3efd7ef29d7e4ce6f003b62795aef2ee.png'"
              />
            </div>
            <div class="text-wrapper_6 flex-col justify-end">
              <span class="text_25">优势</span>
              <span class="text_26">04</span>
            </div>
          </div>
          <div class="box_20 flex-row justify-between">
            <div class="box_21 flex-col">
              <div class="text-group_5 flex-col justify-between">
                <span class="text_27">优势</span>
                <span class="text_28">05</span>
              </div>
            </div>
            <div class="box_22 flex-col">
              <span class="text_29">中小学体适能评估及训练</span>
              <img
                class="thumbnail_12"
                referrerpolicy="no-referrer"
                v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNG1a662e15cb2aaf165a44a40d0165eae0.png'"
              />
            </div>
          </div>
          <div class="box_23 flex-row justify-between">
            <div class="group_23 flex-col">
              <span class="text_30">长者体适能监测及干预</span>
              <img
                class="thumbnail_13"
                referrerpolicy="no-referrer"
                v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNG3efd7ef29d7e4ce6f003b62795aef2ee.png'"
              />
            </div>
            <div class="text-wrapper_7 flex-col justify-end">
              <span class="text_31">优势</span>
              <span class="text_32">06</span>
            </div>
          </div>
        </div>
      </div>
      <div class="box_24 flex-row">
        <div class="text-group_6 flex-col justify-between">
          <span class="text_33">50+</span>
          <span class="text_34">常见疾病康复方案</span>
        </div>
        <img
          class="image_8"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNGd69f1a80b63f958e2887dc31390cf9d5.png'"
        />
        <div class="text-group_7 flex-col justify-between">
          <span class="text_35">70+</span>
          <span class="text_36">肌肉群组的训练及拉伸</span>
        </div>
        <img
          class="image_9"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNGd69f1a80b63f958e2887dc31390cf9d5.png'"
        />
        <div class="text-group_8 flex-col justify-between">
          <span class="text_37">2000+</span>
          <span class="text_38">处方动作视频</span>
        </div>
        <img
          class="image_10"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNGd69f1a80b63f958e2887dc31390cf9d5.png'"
        />
        <div class="text-group_9 flex-col justify-between">
          <span class="text_39">5000+</span>
          <span class="text_40">小时拍摄制作</span>
        </div>
      </div>
    </div>
    <div class="box_25 flex-col">
      <div class="box_26 flex-row">
        <div class="group_24 flex-col"></div>
        <img
          class="thumbnail_14"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/736af385b5714bfa9b5e9ad2445c8e8a_mergeImage.png'"
        />
        <div class="image-text_3 flex-row justify-between">
          <div class="group_25 flex-col">
            <div class="box_27 flex-col"></div>
            <span class="text-group_10">体适能测评仪测评项目</span>
          </div>
          <div class="image-wrapper_7 flex-col">
            <img
              class="thumbnail_15"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNG0efce337b16177f7b543ef01704cf6f6.png'"
            />
          </div>
        </div>
      </div>
      <div class="box_28 flex-row justify-between">
        <div class="group_26 flex-row">
          <div class="image-text_4 flex-col justify-between">
            <img
              class="label_2"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNGb9fab769d269871c66591c3934b5cc8d.png'"
            />
            <div class="text-group_11 flex-col justify-between">
              <span class="text_41">心肺适能</span>
              <span class="paragraph_1">
                全身性运动与体力活动
                <br />
                持久能力的最重要指标
              </span>
            </div>
          </div>
        </div>
        <div class="group_27 flex-row">
          <div class="image-text_5 flex-col justify-between">
            <img
              class="label_3"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNG05baa658c17094d4fbb4c8204f44e65e.png'"
            />
            <div class="text-group_12 flex-col justify-between">
              <span class="text_42">肌耐力</span>
              <span class="paragraph_2">
                身体持续比较长时间
                <br />
                的运动能力
              </span>
            </div>
          </div>
        </div>
        <div class="group_28 flex-row">
          <div class="image-text_6 flex-col justify-between">
            <img
              class="label_4"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNGbc185500eed2a5f3b63e5bb10044222a.png'"
            />
            <div class="text-group_13 flex-col justify-between">
              <span class="text_43">反应时</span>
              <span class="text_44">测试反应能力</span>
            </div>
          </div>
        </div>
      </div>
      <div class="box_29 flex-row justify-between">
        <div class="block_8 flex-row">
          <div class="image-text_7 flex-col justify-between">
            <img
              class="label_5"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNGa31685268c9daee62f64407cb8f362ee.png'"
            />
            <div class="text-group_14 flex-col justify-between">
              <span class="text_45">三公尺折返走</span>
              <span class="paragraph_3">
                测试反应能力、敏捷性
                <br />
                和动态平衡能力
              </span>
            </div>
          </div>
        </div>
        <div class="block_9 flex-row">
          <div class="image-text_8 flex-row">
            <div class="text-group_15 flex-col justify-between">
              <span class="text_46">五次坐站</span>
              <span class="text_47">测试下肢肌力</span>
            </div>
            <img
              class="label_6"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNGe3c573a7b58b590d5392bdfdaa45f23d.png'"
            />
          </div>
        </div>
        <div class="block_10 flex-row">
          <div class="image-text_9 flex-col justify-between">
            <img
              class="label_7"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNG19d5c97224ef9593c116f312e6de38b3.png'"
            />
            <div class="text-group_16 flex-col justify-between">
              <span class="text_48">功能性伸展</span>
              <span class="text_49">评估柔韧性及下肢平衡肌力</span>
            </div>
          </div>
        </div>
      </div>
      <div class="box_30 flex-row justify-between">
        <div class="block_11 flex-row">
          <div class="image-text_10 flex-col justify-between">
            <img
              class="label_8"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNG08e33d93bb685bc6416f19f85a5ff925.png'"
            />
            <div class="text-group_17 flex-col justify-between">
              <span class="text_50">台阶实验</span>
              <span class="text_51">测量评估心肺耐力</span>
            </div>
          </div>
        </div>
        <div class="block_12 flex-row">
          <div class="image-text_11 flex-col justify-between">
            <img
              class="label_9"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNG0331240c6ce50f46db86fe8d431ee97f.png'"
            />
            <div class="text-group_18 flex-col justify-between">
              <span class="text_52">睁眼平衡</span>
              <span class="text_53">评估身体平衡的协调能力</span>
            </div>
          </div>
        </div>
        <div class="block_13 flex-row">
          <div class="image-text_12 flex-col justify-between">
            <img
              class="label_10"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNG4c1c607132cf86ee6bb649018fa6b35a.png'"
            />
            <div class="text-group_19 flex-col justify-between">
              <span class="text_54">闭眼平衡</span>
              <span class="text_55">评估静态平衡能力</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box_31 flex-col">
      <div class="section_c9 flex-row">
        <div class="group_c29 flex-col"></div>
        <img
          class="thumbnail_c16"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/c55f56d2ef0947aa9ee8840b23af75f2_mergeImage.png'"
        />
        <div class="image-text_c13 flex-row justify-between">
          <div class="box_c32 flex-col">
            <div class="section_c10 flex-col"></div>
            <span class="text-group_c20">体适能测评仪测评报告</span>
          </div>
          <div class="image-wrapper_c8 flex-col">
            <img
              class="thumbnail_c17"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNG0efce337b16177f7b543ef01704cf6f6.png'"
            />
          </div>
        </div>
      </div>
      <div  class="in_c9 flex-row">
        <img
          class="image_c10"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNGcf16534aecefab4a664ad57a53c53d41.png'"
        />
      </div>
      <div class="section_9 flex-row">
        <div class="group_29 flex-col"></div>
        <img
          class="thumbnail_16"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/c55f56d2ef0947aa9ee8840b23af75f2_mergeImage.png'"
        />
        <div class="image-text_13 flex-row justify-between">
          <div class="box_32 flex-col">
            <div class="section_10 flex-col"></div>
            <span class="text-group_20">规格参数</span>
          </div>
          <div class="image-wrapper_8 flex-col">
            <img
              class="thumbnail_17"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/evaluation_h5/FigmaDDSSlicePNG0efce337b16177f7b543ef01704cf6f6.png'"
            />
          </div>
        </div>
      </div>
      <span class="paragraph_4">
        产品名称:&nbsp;健康体适能测评仪&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;显示器:&nbsp;电容触摸LCD液晶显示器&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;摄像头:&nbsp;双目摄像头、3D摄像头
        <br />
        通讯接口:&nbsp;USB、蓝牙&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;额定电压:&nbsp;220V&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;包装配件:&nbsp;握力计、肺活量计
        <br />
        产品尺寸:&nbsp;50x68x200cm
      </span>

    </div>
    <footerMask/>

  </div>
</template>
<script>
import headerMask from "../../components/headery";
import footerMask from "../../components/footert";

export default {
  components: {
    headerMask,
    footerMask
  },
  async mounted() {
    
    let weight = window.screen.width
    console.log(weight, 'ddddddddddddd')
    if(weight >= 1200){
      this.$router.push({path: '/evaluation'})
    }
  
  },
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.response.css" />